/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_COMMITTE_LIST = gql`
query GetAllCommitteInviteStatus($filter: CommitteFilterInput, $options: GetManyOptions) {
    getAllCommitteInviteStatus(filter: $filter, options: $options) {
      count
      limit
      skip
      content {
        id
        firstName
        lastName
        email
        Invites {
        id
          presentation {
            id
            name
            year
            status
          }
          maxInvites
          partition
          purchased
          referalsUsed
          sectionOptType
          sections {
            id
            name
          }
        }
      }
    }
  }
`;
